export default __webpack_public_path__ + "static/media/config.63e7b9e8.svg";